// For use with later refactoring of PriceCalculation page.

// import Extent from '../../shared/components/Extent'

const parts = {
  tag: 1,
  fordor: 2,
  bagdor: 3,
  forskaerm: 4,
  forkofanger: 5,
  forklap: 6,
  bagskaerm: 7,
  bagkofanger: 8,
  bagklap: 9,
  panel: 10,
  faelg: 11
}

export default class ExtentAdapter {
  constructor () {
    this.extent = null
  }

  /**
   * Sets the Extent component used in the adapter.
   * @param {Extent} extent
   */
  setExtent (extent) {
    if (extent !== undefined) {
      this.extent = extent
      // console.log('Extent set in adapter')
    }
  }

  /**
   *
   * @param {String} type Event type
   * @param {*} detail Event detail
   */
  onCarItem (type, detail) {
    // console.log('onCarItem', type, detail)

    if (detail.length !== undefined) {
      for (let i = 0; i < detail.length; i++) {

      }
    }
  }

  /**
   * Get PartId from a string
   * @param {String} val
   */
  getPartId (val) {
    let keys = Object.keys(parts)
    for (let i = 0; i < keys.length; i++) {
      if (val.includes(keys[i])) return parts[keys[i]]
    }
    return -1
  }

  /**
   * Get TaskId from a string
   * @param {String} val
   */
  getTaskId (val) {
    let parts = val.split('_')
    let part = parts[parts.length - 1]
    let id = parseInt(part)
    if (isNaN(id)) return -1
    return id
  }

  /**
   * Get TaskSide from a string
   * @param {String} val
   */
  getTaskSide (val) {
    let left = false
    let right = false
    let front = false
    let back = false

    let parts = val.split('-')
    if (parts.includes('venstre')) left = true
    if (parts.includes('hojre')) right = true
    if (parts.includes('for')) front = true
    if (parts.includes('bag')) back = true

    if (front && left) return 5
    if (front && right) return 6
    if (back && left) return 7
    if (back && right) return 8

    if (front) return 3
    if (back) return 4

    if (left) return 1
    if (right) return 2

    return 0
  }
}




// WEBPACK FOOTER //
// ./src/app/pages/PriceCalculation/ExtentAdapter.js